import Cookies from 'js-cookie';
import ConfigRankingCompute from '../configs/ConfigRankingCompute';

// PRO-13778: the photo-match tag dictionary (analytic.photo_match_tag_dictionary),
// edited here and served by ranking-compute straight to the before/after photo form.
// Every call needs Authorization: writes 403 {code:"not_editor"} unless the caller's
// user_id is on ranking-compute's PHOTO_DICT_EDITORS allow-list (see modules.photo_match
// .dictionary_admin on that service) — reads are open to any authenticated admin.
const BASE = '/photo-match/dictionary';
const headers = () => ({ Authorization: Cookies.get('adminToken') });

const getLangs = () => ConfigRankingCompute.get(`${BASE}/langs`, { headers: headers() });

const getTags = (params) => ConfigRankingCompute.get(`${BASE}/tags`, { params, headers: headers() });

const getTag = (id) => ConfigRankingCompute.get(`${BASE}/tags/${id}`, { headers: headers() });

const createTag = (data) => ConfigRankingCompute.post(`${BASE}/tags`, data, { headers: headers() });

const updateTag = (id, data) => ConfigRankingCompute.put(`${BASE}/tags/${id}`, data, { headers: headers() });

const deleteTag = (id) => ConfigRankingCompute.delete(`${BASE}/tags/${id}`, { headers: headers() });

const getOperations = (params) => ConfigRankingCompute.get(`${BASE}/operations`, { params, headers: headers() });

const translate = (data) => ConfigRankingCompute.post(`${BASE}/translate`, data, { headers: headers() });

export default {
  getLangs,
  getTags,
  getTag,
  createTag,
  updateTag,
  deleteTag,
  getOperations,
  translate,
};
